export default __webpack_public_path__ + "static/media/icon15.1fbb5359.svg";